export * from './block.module';
export * from './block.component';



// WEBPACK FOOTER //
// ./src/app/layout/block/index.ts